var jcnbolig = jcnbolig || {};
( function () {
    'use strict';
    jQuery( function () {
        jcnbolig.init();
    } );
    jcnbolig.init              = function () {
        jcnbolig.courses.init();
    };
    jcnbolig.courses      = {
        init: function () {
            if ( jQuery( '.js-jcnbolig-carousel-slider' ).length > 0 ) {
                jcnbolig.courses.slick();
            }
        },
        slick: function () {
            jQuery('.js-jcnbolig-carousel-slider').slick({
                slidesToShow: 3,
                slidesToScroll: 3,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        }
    };
    
}() );



jQuery( ".custom-video-banner" )
  .closest( ".e-section" ).addClass('e-section-video-banner');